import { ShieldAlert } from 'lucide-react'

interface AccessDeniedProps {
  userId: string | undefined
}

export function AccessDenied({ userId }: AccessDeniedProps) {
  return (
    <div className="flex h-screen items-center justify-center bg-[#0d0e12] p-4 font-sans text-xs">
      <div className="max-w-md w-full rounded-lg border border-red-950/40 bg-red-950/10 p-6 shadow-2xl backdrop-blur-md">
        <div className="flex items-center space-x-3 text-red-400">
          <ShieldAlert className="h-5 w-5" />
          <h1 className="text-sm font-bold uppercase tracking-wider">Access Denied</h1>
        </div>
        <p className="mt-3 text-[#94a3b8] leading-relaxed">
          Merels Platform Administration is restricted to verified accounts.
        </p>
        {userId ? (
          <div className="mt-4 rounded bg-black/40 p-3 font-mono text-[10px] text-red-300 border border-red-900/30">
            User ID: <span className="select-all font-semibold">{userId}</span>
          </div>
        ) : (
          <p className="mt-4 text-[#64748b]">Please sign in to authenticate.</p>
        )}
      </div>
    </div>
  )
}
